<template>
  <div class="banner-search" :class="{ design: isDesignActive }">
    <div ref="search-bar-banner" class="w-100 text-center">
      <SearchBar
        :prismic-keyword="prismicKeyword"
        :is-banner="true"
        :show-wrapper-border="isDesignActive"
      />
    </div>
  </div>
</template>

<script>
const SearchBar = () => import('@/components/SearchBar');
import { mapGetters } from 'vuex';

export default {
  name: 'BannerSearch',
  components: {
    SearchBar
  },
  props: {
    prismicKeyword: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      observer: undefined
    };
  },
  computed: {
    ...mapGetters('experience', ['isDesignActive'])
  },
  mounted() {
    let searchBarRef = this.$refs['search-bar-banner'];
    this.observer = new IntersectionObserver(
      (entry) => {
        if (entry[0].target.getBoundingClientRect().top > 0) {
          this.$store.commit('searchBar/SET_BAR_HOME_TOP', false);
        } else {
          this.$store.commit('searchBar/SET_BAR_HOME_TOP', true);
        }
      },
      {
        root: null,
        threshold: 1.0
      }
    );
    this.observer.observe(searchBarRef);
  },
  beforeDestroy() {
    this.observer.disconnect();
    this.$store.commit('searchBar/SET_BAR_HOME_TOP', false);
  }
};
</script>

<style lang="scss" scoped>
.banner-search {
  width: 100%;
  position: relative;
  z-index: 200;
  &.design {
    box-shadow: 10px 0px 40px -10px rgba(0, 0, 0, 0.2);
    border-radius: 25px;
  }
  @include lg {
    display: none;
  }
}
</style>
